module.exports = __webpack_public_path__ + "static/media/video.fbc9949e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/MensHealthWA/video.jpg
// module id = 242
// module chunks = 0